import {Flux} from '@nlabs/arkhamjs';
import {FluxProvider} from '@nlabs/arkhamjs-utils-react';
import type {GothamRouteData} from '@nlabs/gothamui';
import type {ReactElement} from 'react';
import {useEffect, useState} from 'react';
import {WorkspaceRuntime} from './WorkspaceRuntime.js';

export type WorkspaceProviderProps = {
  readonly appId: string;
  readonly children?: ReactElement | ReactElement[];
  readonly name: string;
  readonly routes?: GothamRouteData[];
};

let fluxInitialization: Promise<void> | undefined;

const initializeFlux = (name: string): Promise<void> => {
  if(Flux.isInit) {
    return Promise.resolve();
  }
  fluxInitialization ||= (async () => {
    await Flux.init({name});
  })();
  return fluxInitialization;
};

export const WorkspaceProvider = (props: WorkspaceProviderProps): ReactElement => {
  const [fluxReady, setFluxReady] = useState(Flux.isInit);

  useEffect(() => {
    let mounted = true;
    const prepareFlux = async () => {
      await initializeFlux(props.appId);
      if(mounted) {
        setFluxReady(true);
      }
    };
    void prepareFlux();
    return () => {
      mounted = false;
    };
  }, [props.appId]);

  return <FluxProvider flux={Flux}>
    {fluxReady ? <WorkspaceRuntime {...props} /> : <div className="min-h-screen bg-reaktor-page" />}
  </FluxProvider>;
};
